<template>
    <div class="vendor">
      <div class="vendor-header">
            <div class="title s">
                <h2>Linked Vendors</h2>
            </div>
            <button  class="btn mr-3 pointer" @click="getVendorList">
            <img src="~@/assets/images/link.svg" width="12px" alt="" />
        <span class="ml-2 s">Link vendor</span></button></div>
          <div v-if="isLoading" class="p-20 h-center">
        <loading-circle />
      </div>
       <div
      v-else-if="linkedVendors.length === 0 && !isLoading"
     class="p-20 h-center"
    >
      <span class="text">No Vendors are attached</span>
    </div>
      <div v-if="linkedVendors.length" class="vendor-container">
  <div class="list" v-for="(item, index) in linkedVendors" :key="index">
    <label class="m weight-500">{{ item?.tenant_company_association?.target_tenant?.company_name }}</label>
    <p class="name s">{{ item.tenant_company_association?.target_tenant?.industry_vertical_value?.name }}</p>
    <a class="email s">{{ item.tenant_company_association?.target_tenant?.company_email }}</a>
  </div>
</div>
<modal :open="isOpen" @close="isOpen = false" :title="`Link Vendor to ${activeFactory.name}`">
  <div class="vendor-card-container" v-if="activeVendors.length">
    <div class="vendor-card default-vendor" v-for="(vendor, key) in activeVendors" :key="key">
        <div class="card-details">
          <div class="card-header">
            <h4>{{ vendor.target_tenant?.company_name }}</h4>
          </div>
          <div>
           <span class="s">{{ vendor.target_tenant?.industry_vertical_value?.name }}</span>
          </div>
        </div>
        <div class="linkBtn">
          <button v-if="!vendor.isLinking" class="px-2 s btn ml-2 pointer" @click="addVendorToFactory(vendor)">Link Vendor</button>
          <button v-else class="s py-1 px-2 linked" >Linked</button>
          </div>
      </div>
    </div>
     <div
      v-else-if="activeVendors.length === 0"
     class="p-15 h-center"
    >
      <span class="text">No active vendors.</span>
    </div>
</modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AddVendorToFactory, GetLinkedVendorsList } from '@/api'
import Modal from '../common/modal.vue'
import { alert, success } from '@/plugins/notification'
import loadingCircle from '../common/loadingCircle.vue'
export default {
  name: 'Vendors',
  components: { Modal, loadingCircle },
  props: {
    activeFactory: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      linkedVendors: [],
      activeVendors: []
    }
  },
  computed: {
    ...mapGetters(['childTenantsList', 'user'])
  },
  methods: {
    buildActiveVendors () {
      this.activeVendors = this.childTenantsList
        .filter(item =>
      item?.target_tenant?.approval_instances?.some(
        a => a?.state_value?.name === 'COMPLETED'
      )
        )
        .map(item => ({
          ...item,
          isLinking: this.linkedVendors.some(v =>
        v?.tenant_company_association?.target_tenant?.id ===
        item?.target_tenant?.id
          )
        }))
    },
    getVendorList () {
      this.isOpen = true
      this.buildActiveVendors()
    },
    addVendorToFactory (vendorRow) {
      if (vendorRow.isLinking || vendorRow.linked) return
      vendorRow.isLinking = true
      const defaultCollab = [
        {
          target_tenant_id: vendorRow.target_tenant.id
        }
      ]
      AddVendorToFactory(defaultCollab).then((res) => {
        if (res.insert_factory_company_association) {
          vendorRow.linked = true
          success('Vendor linked successfully')
          return GetLinkedVendorsList(this.activeFactory.id)
        }
      }).then(res => {
        this.linkedVendors = res.factory_company_association
        this.buildActiveVendors()
      }).catch(err => {
        alert(err)
        vendorRow.isLinking = false
      })
    },
    init () {
      this.isLoading = true
      GetLinkedVendorsList(this.activeFactory.id).then(res => {
        this.linkedVendors = res.factory_company_association
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    activeFactory () {
      this.linkedVendors = []
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.vendor {
    &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .title {
            display: flex;
            align-items: center;
            gap: 6px;

            h2 {
                font-size: var(--text-base);
                font-weight: 400;
            }
        }
    }
}
.vendor-card-container {
  max-height: 73vh;
  overflow: auto;
  padding-right: 11px;
}
.vendor-card {
  display: flex;
  border: 2.2px solid #d8d6d3;
  border-radius: 8px;
  margin-top: 23px;
  gap: 20px;
  padding: 20px;
}
.card-details {
  flex-grow: 1;
}
.linkBtn {
  place-content: center;
}
.vendor-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(282px, 1fr));
    gap: 14px;
    overflow-y: auto;
    max-height: calc(100vh - 360px);
    padding-right: 26px;
}

.list {
  padding: 20px 22px;
  border-radius: 14px;
  background: #fff;
  box-sizing: border-box;
  border: 2.2px solid #d8d6d3;
  margin-top: 12px;
}

.name {
  margin: 7px 0 10px;
  font-size: var(--text-base);
  color: var(--text-secondary);
}

.email {
  color: #6767ed;;
  text-decoration: none;
}
.email:hover {
  text-decoration: underline;
}
.linked {
  border: 2.2px solid #d8d6d3;
  border-radius: 4px;
}
</style>
